/* eslint-disable import/no-anonymous-default-export */
import shippingSlice from "./shippingSlice";
import { config } from "../utils/config";
import { logSentry } from "../utils/sentry";
import { setAddAddressFormState, setIsCouponAppliedOnShipping, startLoading, stopLoading, setCustomerStatus, setSentryNavigationTrackingStateNull } from "./application";
import { get, set as setCookie, setCookieForSession } from "../utils/cookies";
import abcService from "../services/abc";
import shippingUtils from '../utils/shipping';
import { vatValidationApi } from "./vatValidation";
import { cartApi } from "./cart";
import { getCart , newCartApi } from "./newCart";
import { customerApi } from "./customer";
import { loqateApi } from "./loqate";
import { LoginUserEditFormState, EmailValidationStatus, ErrorMessage } from "../enums/checkoutShipping";
import { Address } from "../enums/checkoutShipping";
import { recaptchaApi } from "./recaptcha";
import Customer from "../models/customer";
import { errorTrackingGaEvent, newsletterEvent } from "../utils/analytics/google";
import { customerGdprAPI } from "./customerGdpr";
import { saveGuestAddressFormInStorage } from "../utils/guestRetention";
import i18n from '../utils/translations/i18n'
import { get as getFromLocalStorage, set as setInLocalStorage } from '../utils/storage/localStorage';
import { checkIfAddressModified, verifyAddressWithLoqate } from "../utils/shipping/loqate";
import paypal from "./paypal";
import customerActions from "./customerActions";
import { ShipmentType } from "../enums/ShipmentType";
import Cart from "../models/cart";
import { calculateThresholdStatus } from "../utils/cart";
import { Page } from "../enums/page";

declare const window: any;

const setShippingAddress = (address: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.shippingAddress({ 'shippingAddress': address }));
    }
}
const setBillingAddress = (address: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.billingAddress({ 'billingAddress': address }))
    }
}
const setShowShippingError = (showShippingError: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.showShippingError({ 'showShippingError': showShippingError }));
    }
}
const setShippingError = (shippingError: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.shippingError({ 'shippingError': shippingError }))
    }
}
const setShippingBillingAgreement = (flag: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.shippingBillingAgreement({ 'flag': flag }))
    }
}
const setCustomerVersion = (customerVersion: number) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setCustomerVersion({ 'customerVersion': customerVersion }))
    }
}

const setCurrentSelectedCountry = (countryCode: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setCurrentSelectedCountry({ 'country': countryCode }))
    }
}
const setOldVatCountry = (oldVatCountry: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setOldVatCountry({ 'oldVatCountry': oldVatCountry }))
    }
}
const setOldVatId = (oldVatId: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setOldVatId({ 'oldVatId': oldVatId }))
    }
}
const setVatStatus = (vatStatus: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setVatStatus({ 'vatStatus': vatStatus }))
    }
}
const setIsManualShippingAddress = (isManualShippingAddress: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setIsManualShippingAddress({ 'isManualShippingAddress': isManualShippingAddress }))
    }
}
const setIsManualBillingAddress = (isManualBillingAddress: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setIsManualBillingAddress({ 'isManualBillingAddress': isManualBillingAddress }))
    }
}
const setDefaultShippingAddress = (defaultShippingAddress: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setDefaultShippingAddress({ 'defaultShippingAddress': defaultShippingAddress }))
    }
}
const setDefaultBillingAddress = (defaultBillingAddress: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setDefaultBillingAddress({ 'defaultBillingAddress': defaultBillingAddress }))
    }
}
const setOldVat = (oldVat: number) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setOldVat({ 'oldVat': oldVat }))
    }
}
const setOldUsbVat = (oldUsbVat: number) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setOldUsbVat({ 'oldUsbVat': oldUsbVat }))
    }
}
const setUpdateVatMsg = (updatedMsg: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setUpdateVatMsg({ 'updatedMsg': updatedMsg }))
    }
}
const setShipAddressModified = (shipAddressModified: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setShipAddressModified({ 'shipAddressModified': shipAddressModified }))
    }
}
const setBillAddressModified = (billAddressModified: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBillAddressModified({ 'billAddressModified': billAddressModified }))
    }
}

const setIsValidEmail = (isValidEmail: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setIsValidEmail({ 'isValidEmail': isValidEmail }))
    }
}
const setIsPostalCodeBlur = (isPostalCodeBlur: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setIsPostalCodeBlur({ 'isPostalCodeBlur': isPostalCodeBlur }))
    }
}

const setValidatedEmail = (email: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setValidatedEmail({ 'validatedEmail': email }))
    }
}
const setMoveToPaymentPage = (moveToPaymentPage: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setMoveToPaymentPage({ 'moveToPaymentPage': moveToPaymentPage }))
    }
}
const setLoqateEnabled = (loqateEnabled: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setLoqateEnabled({ 'loqateEnabled': loqateEnabled }))
    }
}
const setSuggestedShippingAddress = (suggestedShippingAddress: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setSuggestedShippingAddress({ 'suggestedShippingAddress': suggestedShippingAddress }))
    }
}
const setSuggestedBillingAddress = (suggestedBillingAddress: any) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setSuggestedBillingAddress({ 'suggestedBillingAddress': suggestedBillingAddress }))
    }
}
const setShippingAddressType = (addressType: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setShippingAddressType({ 'addressType': addressType }))
    }
}
const setBillingAddressType = (addressType: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBillingAddressType({ 'addressType': addressType }))
    }
}
const setIsLoqateSuggestedAddress = (isLoqateSuggestedAddress: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setIsLoqateSuggestedAddress({ 'isLoqateSuggestedAddress': isLoqateSuggestedAddress }))
    }
}
const setFormattedShippingAddress = (formattedShippingAddress: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setFormattedShippingAddress({ 'formattedShippingAddress': formattedShippingAddress }))
    }
}
const setFormattedBillingAddress = (formattedBillingAddress: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setFormattedBillingAddress({ 'formattedBillingAddress': formattedBillingAddress }))
    }
}
const setShowShippingPopup = (showShippingPopup: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setShowShippingPopup({ 'showShippingPopup': showShippingPopup }))
    }
}
const setShowBillingPopup = (showBillingPopup: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setShowBillingPopup({ 'showBillingPopup': showBillingPopup }))
    }
}
const setBlockShippingLoqateAutocomplete = (blockShippingLoqateAutocomplete: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBlockShippingLoqateAutocomplete({ 'blockShippingLoqateAutocomplete': blockShippingLoqateAutocomplete }))
    }
}
const setBlockBillingLoqateAutocomplete = (blockBillingLoqateAutocomplete: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBlockBillingLoqateAutocomplete({ 'blockBillingLoqateAutocomplete': blockBillingLoqateAutocomplete }))
    }
}
const setShippingAQI = (shippingAQI: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setShippingAQI({ 'shippingAQI': shippingAQI }))
    }
}
const setBillingAQI = (billingAQI: string) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBillingAQI({ 'billingAQI': billingAQI }))
    }
}
const setTaxRateActions = (taxActions: []) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setTaxRateActions({ 'taxActions': taxActions }))
    }
}
const setCartAddressAdded = (cartAddressAdded: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setCartAddressAdded({ 'cartAddressAdded': cartAddressAdded }))
    }
}
const setBackToPreviousPage = (backToPreviousPage: boolean) => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setBackToPreviousPage({ 'backToPreviousPage': backToPreviousPage }))
    }
}
const setLoginUserEditFormState = (state = LoginUserEditFormState.CLOSE, editAddressId = '', editAddressType = Address.SHIPPING, editedByUser = true, shippingAddressId = '',  billingAddressId = '') => {
    return (dispatch) => {
        dispatch(shippingSlice.actions.setLoginUserEditFormState({ loginUserEditForm: { state, editAddressId, editAddressType, editedByUser, shippingAddressId, billingAddressId } }));
    }
}

const setContactPreferencesState = (email , subscribe , displayError, isEmailChanged=false, displayContactPreference=true) => {
    return (dispatch) => {
        try{
            dispatch(shippingSlice.actions.setContactPreferencesState({contactPreference : {emailAddress: email,
            subscribe: subscribe , displayError: displayError, isEmailChanged: isEmailChanged, displayContactPreference: displayContactPreference }}));
        }
        catch(error){
            throw error; //eslint-disable-line
        }
    }
}

const updateLoqateAddressField = (customerId, addressId, customFieldObj) => {
    return async (dispatch, getState) => {
        try {
            dispatch(setShowShippingError(false));
            const loqateFieldObj = [{
                'addressId': addressId,
                'name': 'loqateInformation',
                'value': JSON.stringify(customFieldObj)
            }];
            const response = await dispatch(loqateApi.endpoints.updateLoqateAddressField.initiate({ customerId, loqateFieldObj }));
            if (response?.data?.data?.statusCode === 200) {
                return true;
            } else {
                const errorMessage = (response.message) ? response.message : i18n.t('sign_up.somethingWrong');
                dispatch(setShowShippingError(true));
                dispatch(setShippingError(errorMessage));
                errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
                return false;
            }
        } catch (err) {
            console.log('Error while updating Loqate address field');
        }
    }
}
const updateLoqateAddressFieldMyAccount = (customerId, addressId, addressType) => {
    return async (dispatch, getState) => {
        try {
            const {
                shippingState: {
                    loqate: { shippingAddressType, billingAddressType, shippingAQI, billingAQI }
                },
            } = getState();
            let customField: any = {};
            if(addressType === Address.SHIPPING){
                if(shippingAddressType === Address.USER_VALIDATED){
                    customField.addressValidationType = shippingAddressType
                }
                else{
                    customField.AQI = shippingAQI || 'A';
                    customField.addressValidationType = shippingAddressType
                }
            }
            else{
                if(billingAddressType === Address.USER_VALIDATED){
                    customField.addressValidationType = billingAddressType
                }
                else{
                    customField.AQI = billingAQI || 'A';
                    customField.addressValidationType = billingAddressType
                }
            }
            dispatch(setShowShippingError(false));
            const loqateFieldObj = [{
                'addressId': addressId,
                'name': 'loqateInformation',
                'value': JSON.stringify(customField)
            }];
            const response = await dispatch(loqateApi.endpoints.updateLoqateAddressField.initiate({ customerId, loqateFieldObj }));
            if (response?.data?.data?.statusCode === 200) {
                return true;
            } else {
                const errorMessage = (response.message) ? response.message : i18n.t('sign_up.somethingWrong');
                dispatch(setShowShippingError(true));
                dispatch(setShippingError(errorMessage));
                errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
                return false;
            }
        } catch (err) {
            console.log('Error while updating Loqate address field');
        }
    }
}

const getLoqateInformation = (addressType) => {
    return (dispatch, getState) => {
        const {
            shippingState: {
                loqate:  { shippingAddressType, billingAddressType, shippingAQI, billingAQI }
            }
        } = getState();

        let customField: any = {};
        if(addressType === Address.SHIPPING){
            if(shippingAddressType === Address.USER_VALIDATED){
                customField.addressValidationType = shippingAddressType
            }
            else{
                customField.AQI = shippingAQI || 'A';
                customField.addressValidationType = shippingAddressType
            }
        }
        else{
            if(billingAddressType === Address.USER_VALIDATED){
                customField.addressValidationType = billingAddressType
            }
            else{
                customField.AQI = billingAQI || 'A';
                customField.addressValidationType = billingAddressType
            }
        }
        return JSON.stringify(customField);
    }
}

const getAddressData = (customer, formType, addressForm) => {
    return (dispatch, getState) => {
        const {
            applicationState: { user },
            shippingState: {
                address: { shippingAddress, billingAddress }
            }
        } = getState();
        let addressType = formType === Address.SHIPPING_ADDRESS ? Address.SHIPPING : Address.BILLING;
        const { newAddress } = validateMissingFieldsInAddressMyAccount(formType === Address.SHIPPING_ADDRESS ? shippingAddress : billingAddress, formType, addressForm, user, customer)
        addressType === Address.SHIPPING ? dispatch(setShippingAddress(newAddress)) : dispatch(setBillingAddress(newAddress));
        
        const loqateInformation = dispatch(getLoqateInformation(addressType));
        return { newAddress, loqateInformation };
    }
}

const loqateModalFunction = (addressForm, type, setShowLoqateModal) => {
    return async (dispatch, getState) => {
        const {
            applicationState: { user, currentPage },
            shippingState: {
                loqate: { loqateEnabled, shippingAddressType, suggestedShippingAddress, suggestedBillingAddress, billingAddressType},
                address: { defaultShippingAddress, defaultBillingAddress },
            },
        } = getState();

        const { shippingData, billingData } = shippingUtils.getShippingBillingAddressMyAccount(addressForm, type, user.isLoggedIn, user.email);
        let shippingAddressStatus: string = Address.UNKNOWN;
        let billingAddressStatus: string = Address.UNKNOWN;
        type === Address.SHIPPING_ADDRESS && dispatch(setShippingAddress(shippingData));
        type === Address.BILLING_ADDRESS && dispatch(setBillingAddress(billingData));

        if (Object.keys(suggestedBillingAddress).length > 0 && billingAddressType !== Address.USER_VALIDATED && type === Address.BILLING_ADDRESS) {
            const isBillingAddressModified = checkIfAddressModified({ suggestedAddress: suggestedBillingAddress, submittedAddress: billingData });
            if (isBillingAddressModified) {
                billingAddressStatus = Address.UNKNOWN;
                dispatch(setBillingAddressType(Address.UNKNOWN));
            } else {
                billingAddressStatus = Address.LOQATE_VALIDATED;
            }
        } else if (Object.keys(defaultBillingAddress).length) {
            billingAddressStatus = billingAddressType;
        }
        if (Object.keys(suggestedShippingAddress).length > 0 && shippingAddressType !== Address.USER_VALIDATED && type=== Address.SHIPPING_ADDRESS) {
            const isShippingAddressModified = checkIfAddressModified({ suggestedAddress: suggestedShippingAddress, submittedAddress: shippingData });
            if (isShippingAddressModified) {
                shippingAddressStatus = Address.UNKNOWN;
                dispatch(setShippingAddressType(Address.UNKNOWN));
            } else {
                shippingAddressStatus = Address.LOQATE_VALIDATED;
            }
        } else if (Object.keys(defaultShippingAddress).length) {
            shippingAddressStatus = shippingAddressType;
        }
        let openLoqateModal: any = false;

        if (loqateEnabled && (shippingAddressStatus === Address.UNKNOWN || billingAddressStatus === Address.UNKNOWN)) {
            openLoqateModal = await verifyAddressWithLoqate({
                dispatch, shippingAddress: {
                    status: shippingAddressStatus,
                    submittedAddress: shippingData,
                    shippingBillingAgreement: false
                },
                billingAddress: {
                    status: billingAddressStatus,
                    submittedAddress: billingData
                },
                isLoggedIn: user.isLoggedIn,
                customerId: user.userId,
                currentPage: currentPage
            });
        }
        if (openLoqateModal) {
            setShowLoqateModal(true);
        }
        return openLoqateModal;
    }
}

const myAccountABCCalls = (addressId, addressType, addressForm, customer, isDefaultSelected, setTriggerUserQueryByCustomer) => {
    return async (dispatch, getState) => {
        dispatch(startLoading());
        const { applicationState: { addAddressFormState } }: any = getState();
        const formType = addressType === Address.BILLING ? Address.BILLING_ADDRESS : Address.SHIPPING_ADDRESS;
        const { newAddress, loqateInformation }: any = await dispatch(getAddressData(customer, formType, addressForm))

        try {
            if(addressId){
                await dispatch(customerActions.editAddress({customer, addressId, addressType, addressData: newAddress, setDefaultAddress: isDefaultSelected, loqateInformation}))
            } else {
                await dispatch(customerActions.addAddress({customer, addressType, addressData: newAddress, setDefaultAddress: isDefaultSelected, loqateInformation}))
            }
            setTriggerUserQueryByCustomer(true);
        } catch (error) {
            dispatch(setAddAddressFormState({ ...addAddressFormState, error:  i18n.t('sign_up.somethingWrong')}));
            dispatch(stopLoading());
        }
    }
}

const updateAddress = async ({customerMeta, addressId, setDefaultAddress, customerAddressData, type, dispatch, loqateInformation}) => {
try {
        let updateCustomerResponse: any;
        updateCustomerResponse = await dispatch(customerActions.editAddress({customer:customerMeta, addressId, addressType:type, addressData: customerAddressData, setDefaultAddress, loqateInformation}));
        return updateCustomerResponse;
    }
    catch(err) {
        console.log('Error while updating customer address');
        errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
        throw err;
    }
}
const createCustomerResponseModel = (updateCustomerResponse, updateAddressFromCart, type) => {
    return (dispatch, getState) => {
        const {applicationState: {user}} = getState();
        const cart = JSON.parse(JSON.stringify(getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {}));
        const customer = new Customer(updateCustomerResponse);
        let updateShippingFromCart = false;
        let updateBillingFromCart = false;
        if(updateAddressFromCart) {
            if(type === Address.SHIPPING) {
                updateBillingFromCart = true;
            } else {
                updateShippingFromCart = true;
            }
        }

        customer.setDefaultShipAndBillFromCart(cart, updateShippingFromCart, updateBillingFromCart);
        return customer;
    }
}
const saveModifiedAddress = ({ type, customerMeta, addressId, customerAddressData, setDefaultAddress }) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startLoading());
            const { applicationState: { user: { userId } }, shippingState: { loqate: { isLoqateSuggestedAddress } } } = getState();
            let customField: any = {};
            customField.AQI = 'A';
            customField.addressValidationType = Address.UNKNOWN;

            if (isLoqateSuggestedAddress) {
                customField.addressValidationType = Address.LOQATE_VALIDATED;
            }

            const loqateInformation = JSON.stringify(customField);
            let updateCustomerResponse = await dispatch(customerActions.editAddress({customer: customerMeta, addressId, addressType: type, addressData: customerAddressData, setDefaultAddress, loqateInformation}));

            const updatedCustomerObject = dispatch(createCustomerResponseModel(updateCustomerResponse, true, type));
            
            dispatch(setIsLoqateSuggestedAddress(false));
            if(type === Address.SHIPPING) {
                updatedCustomerObject.defaultShippingAddressId = addressId;
                dispatch(setShipAddressModified(true));
                dispatch(setShippingAddressType(customField.addressValidationType));
            } else {
                updatedCustomerObject.defaultBillingAddressId = addressId;
                dispatch(setBillAddressModified(true));
                dispatch(setBillingAddressType(customField.addressValidationType));
            }

            await dispatch(customerApi.util.updateQueryData('getCustomerById', { customerId: userId }, (draft) => Object.assign({}, updatedCustomerObject )));
            dispatch(stopLoading());

            return { data: updateCustomerResponse };;
        } catch (err) {
            console.log('Error while saving modified address');
            throw err;
        }
    }
}

const updateAddressesInCustomer = ({ editedShippingAddress, editedBillingAddress }) => {
    return async (dispatch, getState) => {
        try {

            dispatch(startLoading());
            const { applicationState: { user: { userId } }, shippingState: { address: { customerVersion },loqate: { isLoqateSuggestedAddress }, loginUserEditForm : {shippingAddressId, billingAddressId} }, customerState: {customer} } = getState();

            let customField: any = {};
            customField.AQI = 'A';
            customField.addressValidationType = Address.UNKNOWN;
            if (isLoqateSuggestedAddress) {
                customField.addressValidationType = Address.LOQATE_VALIDATED;
            }
            const loqateInformation = JSON.stringify(customField);
            let updateCustomerResponse:any;

            //copy Billing Address object in Shipping Address when Billing and Shipping Addresses are same.
            if (shippingAddressId && billingAddressId && shippingAddressId === billingAddressId) {
                updateCustomerResponse =  await dispatch(customerActions.editAddress({customer, addressId : shippingAddressId, addressType: Address.BILLING_AND_SHIPPING, addressData: editedShippingAddress, loqateInformation}));
            }
            else {
                if (shippingAddressId) {
                    updateCustomerResponse =  await dispatch(customerActions.editAddress({customer, addressId: shippingAddressId, addressType: Address.SHIPPING, addressData: editedShippingAddress, loqateInformation}));
                }
                if (billingAddressId) {
                    updateCustomerResponse =  await dispatch(customerActions.editAddress({customer, addressId : billingAddressId, addressType: Address.BILLING, addressData: editedBillingAddress, loqateInformation}));
                }
            }

            dispatch(setCustomerVersion(updateCustomerResponse?.version));

            if (shippingAddressId) {
                dispatch(setShippingAddressType(customField.addressValidationType));
            }
            if (billingAddressId) {
                dispatch(setBillingAddressType(customField.addressValidationType));
            }

            dispatch(customerApi.util.updateQueryData('getCustomerById', { customerId: userId }, (draft) => Object.assign({}, dispatch(createCustomerResponseModel(updateCustomerResponse, false, '')))));     
                    
            dispatch(setIsLoqateSuggestedAddress(false));
            if(shippingAddressId) {
                dispatch(setShipAddressModified(true));
            }
            if(billingAddressId) {
                dispatch(setBillAddressModified(true));
            }

            dispatch(stopLoading());

            return { data: updateCustomerResponse };;
        } catch (err) {
            console.log('Error while saving modified address');
            throw err;
        }
    }
}
const validateVatNumber = (dispatch, vatId: string, selectedCountry: string, cartId: string, authorizationToken: string) => {
    return async () => {
        try {
            let vatStatus = 'indeterminable';
            if (vatId && config('VAT_ENABLED_COUNTRY').includes(selectedCountry)) {
                /* for DE Locale we want to validate VAT based on billing address. As billing address is same as regionCode
                    we will use the countryCode as DE for DE Locale.    
                */
                const countryCode = config('locale') === 'de-DE' ? config('regionCode') : selectedCountry;
                const payload = {
                    "vatIds": [vatId],
                    "countryCode": countryCode,
                    "requestId": cartId,
                    "enableLiveValidation": true
                };
                const response = await dispatch(vatValidationApi.endpoints.validateVat.initiate({ authorizationToken, ...payload }));

                if (response?.data?.validatedVatIds?.length) {
                    vatStatus = response.data.validatedVatIds[0].status;
                }
            }
            dispatch(setVatStatus(vatStatus));
            dispatch(setOldVatId(vatId));
            dispatch(setOldVatCountry(selectedCountry));

            return vatStatus;
        } catch (error) {
            throw error;
        }
    }
}
const getVatExemption = (cartId: string, selectedCountry: string, currency: string, exemptVAT: boolean) => {
    return async (dispatch) => {
        try {
            return await dispatch(cartApi.endpoints.getVatExemption.initiate({ cartId, selectedCountry, currency, exemptVAT }));
        } catch (error) {
            throw error;
        }
    }
}

const updateOrderSummaryForVat = (cartId: string, selectedCountry: string, vatId: string) => {
    return async (dispatch, getState) => {
        try {

            const { applicationState: { vatToken, sentryNavigationTrackingState }, shippingState: { address: { oldVatCountry, oldVatId, currentSelectedCountry } } } = getState();
            if(vatId != oldVatId || selectedCountry!= oldVatCountry){
                dispatch(startLoading());
                const currency = config('currency');
                const response = await dispatch(validateVatNumber(dispatch, vatId, selectedCountry, cartId, vatToken));
                const exemptVAT = response === 'valid' ? true: false;
                const cartResponse = await dispatch(getVatExemption(cartId, selectedCountry, currency, exemptVAT));
                if(sentryNavigationTrackingState.checkoutShipping !== null && !config('isNASite')){
                    sentryNavigationTrackingState.checkoutShipping.finish();
                    dispatch(setSentryNavigationTrackingStateNull(Page.CHECKOUTSHIPPING));
                }
                if(!exemptVAT){
                    dispatch(setTaxRateActions(shippingUtils.createNonExemptTaxRateActions(cartResponse?.data)));
                    if(config('regionCode') !== currentSelectedCountry){
                        if(!config('isNASite'))
                            dispatch(setUpdateVatMsg(i18n.t('checkout_shipping.price_update_message_VAT')));
                        else dispatch(setUpdateVatMsg(''));
                        //VAT charged per shipping destination message display when invalid VAT Number
                    }
                }else{
                    dispatch(setUpdateVatMsg('')); 
                    //VAT charged per shipping destination message making empty when valid VAT Number
                }
            }
            //tax actions create and update order summary - remaining
        } catch (err) {
            console.log(err);
        }
        finally{
            dispatch(stopLoading());
        }
    }
}

/**
 * @returns customer Id
 */
const getCustomerDetailsByEmail = () => {
    return async (dispatch, getState) => {
        try {
            const { shippingState: { address: { shippingAddress, billingAddress } } } = getState();
            dispatch(setShowShippingError(false));
            let response = await dispatch(customerApi.endpoints.getCustomerByEmail.initiate({ email: shippingAddress?.email }, {forceRefetch: true}));
            let customerId = '';
            if (response?.data?.results) {
                let results = response.data.results;
                customerId = results[0].id;
                if (results.length) {
                    const customer = results[0];
                    // Store customer status in application state
                    dispatch(setCustomerStatus(customer?.custom?.fields?.customerStatus ?? ''));
                    let payload;
                
                    if (customer?.custom?.fields?.customerStatus === 'GUEST_USER') {
                        payload = {
                            firstName: shippingAddress.firstName,
                            lastName: shippingAddress.lastName,
                            company: shippingAddress.company,
                            vatId: shippingAddress.vatId,
                            phone: shippingAddress.phone,
                            email: shippingAddress.email
                        };
                    } else if (customer.isUserDetailsEmpty) {
                        payload = {
                            firstName: billingAddress.firstName,
                            lastName: billingAddress.lastName,
                            email: shippingAddress.email
                        };
                    }
                
                    if (payload && Object.keys(payload).length) {
                        const updateCustomerResponse = await dispatch(customerApi.endpoints.updateCustomer.initiate(payload));
                
                        if (!updateCustomerResponse) {
                            const errorMessage = response?.message || i18n.t('sign_up.somethingWrong');
                            dispatch(setShowShippingError(true));
                            dispatch(setShippingError(errorMessage));
                            errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
                        }
                    }
                }
            }
            return customerId;
        } catch (error: any) {
            const errorMessage = (error.message) ? error.message : i18n.t('sign_up.somethingWrong');
            dispatch(setShowShippingError(true));
            dispatch(setShippingError(errorMessage));
            errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
            throw error;
        }
    }
}

/**
 * @returns customer Id
 */
const createGuestCustomer = () => {
    return async (dispatch, getState) => {
        try {
            const { shippingState: { address: { shippingAddress } } } = getState();
            dispatch(setShowShippingError(false));
            const customerNumber = await abcService.generateCustomerNumber();
            const payload = {
                'firstName': shippingAddress.firstName,
                'lastName': shippingAddress.lastName,
                'company': shippingAddress.company,
                'vatId': shippingAddress.vatId,
                'phone': shippingAddress.phone,
                'email': shippingAddress.email,
                'locale': config('locale'),
                'customerNumber': customerNumber
            };
            let response = await dispatch(customerApi.endpoints.createGuestCustomer.initiate({ ...payload }));
            if (response?.data?.body?.id) return response.data.body.id;
            else return '';
        } catch (error: any) {
            const errorMessage = (error.message) ? error.message : i18n.t('sign_up.somethingWrong');
            dispatch(setShowShippingError(true));
            dispatch(setShippingError(errorMessage));
            errorTrackingGaEvent('checkout-shipping', i18n.t('sign_up.somethingWrong_GA'));
            console.log('Error while creating guest customer');
            throw error;
        }
    }
}

const validateReCaptcha = (cartId) => {
    return async (dispatch) => {
        try {
            const response = await dispatch(recaptchaApi.endpoints.validateCaptcha.initiate(cartId));
            
            // Check if the request was rejected
            if (response?.status === 'rejected' || response?.error) {
                return false;
            }
            
            // Check if response has the expected structure and 'pass' result
            if (response?.data?.data?.result?.toLocaleLowerCase() === 'pass') {
                return true;
            }
            
            // If we get a response but the result isn't 'pass'
            return false;
        } catch (error) {
            // Handle any other errors
            console.log('reCAPTCHA validation error:', error);
            return false;
        }
    }
}
const validatePreferanceReCaptcha = (userId) => {
    return async (dispatch) => {
        const response = await dispatch(recaptchaApi.endpoints.validatePreferenceCaptcha.initiate(userId));
        if (response?.data?.data?.result?.toLocaleLowerCase() === 'pass') {
            return true;
        }
        return false;
    }
}

const updateVatId = (vatId) => {
    return (dispatch, getState) => {
        const updateFields = { vatId: vatId };
        const { applicationState: { user }, shippingState: { address: { customerVersion } } } = getState();
        const customerId = user.userId;
        dispatch(customerApi.endpoints.updateCustomerInfo.initiate({ customerId, customerVersion, updateFields }))
            .then((response) => {
                dispatch(setCustomerVersion(response?.version));
            })
            .catch((error) => {
                console.error('Error while updateVatId in customerInfo', error);
            });
    }
}

const addAddressInCustomer = (customerObj, addressType, customerAddressData, customField, shippingBillingAgreement = false) => {
    return async (dispatch, getState) => {
        let response;
        addressType = shippingBillingAgreement ? Address.BILLING_AND_SHIPPING : addressType;
        
        const loqateInformation = JSON.stringify(customField);
        if(addressType.includes(Address.SHIPPING)) {
            const addressData = JSON.parse(JSON.stringify(customerAddressData));
            addressData.company = addressData.company?.trim() ? addressData.company : undefined
            response = await dispatch(customerActions.addAddress({customer: customerObj, addressType, addressData, loqateInformation , setCustomerCompanyName: true}));
        } else {
            response = await dispatch(customerActions.addAddress({customer: customerObj, addressType, addressData: customerAddressData, loqateInformation}));
        }
        dispatch(setCustomerVersion(response?.version))
        return response;
    }
}

/**
 * Creates new shipping and billing addresses if they are different.
 * @returns {Array} An array containing the newly created shipping and billing addresses.
 */
const addCustomerAddresses = () => {
    return async (dispatch, getState) => {
        let {
            applicationState: { user },
            shippingState: { address: { shippingAddress, billingAddress, isManualShippingAddress, isManualBillingAddress, shippingBillingAgreement, customerVersion }, loqate: {shippingAddressType, billingAddressType, shippingAQI, billingAQI } },
            customerState: { customer }
        } = getState();

        const customField : any = {
            AQI : 'A',
            addressValidationType : Address.UNKNOWN
        }
        let newAddedShipAdd : any = '', newAddedBillAdd : any = '';

        let customerObj = JSON.parse(JSON.stringify(customer))
        if (isManualShippingAddress) {
            if(shippingAddressType === Address.USER_VALIDATED) delete customField.AQI;
            else if(shippingAQI) customField.AQI = shippingAQI;
            customField.addressValidationType = shippingAddressType;
            let shippingResponse = await dispatch(addAddressInCustomer(customerObj, Address.SHIPPING, shippingAddress, customField, shippingBillingAgreement));
            newAddedShipAdd = shippingResponse?.addresses && shippingResponse?.addresses.length && shippingResponse.addresses[shippingResponse.addresses.length - 1];
            customerObj = new Customer(shippingResponse)
            if(shippingBillingAgreement) {
                newAddedBillAdd = newAddedShipAdd;
            }
        } 
        if (isManualBillingAddress && !shippingBillingAgreement) {
            if(billingAddressType === Address.USER_VALIDATED) delete customField.AQI;
            else if(billingAQI) customField.AQI = billingAQI;
            customField.addressValidationType = billingAddressType;
            let billingResponse = await dispatch(addAddressInCustomer(customerObj, Address.BILLING, billingAddress, customField));
            newAddedBillAdd = billingResponse?.addresses && billingResponse?.addresses.length && billingResponse.addresses[billingResponse.addresses.length - 1];
        }
        return [newAddedShipAdd, newAddedBillAdd];
    }
}

/**
 * Updates the shipping address if shouldUpdateAddress is true; 
 * otherwise, updates the Loqate custom field.
 * @returns {Object} The updated customer response.
 */
const updateAddressAndLoqateField = ({shouldUpdateAddress = false, AQI, setDefaultAddress = false , addressValidationType, customerAddress, addressId, type}) => {
    return async (dispatch, getState) => {
        let { applicationState: { user }, customerState : {customer} } = getState();
        let customField : any = {
            AQI : "A",
            addressValidationType : Address.UNKNOWN
        };
        const customerMeta = {email: customer.email, id: customer.id, version: customer.version};
        if(addressValidationType === Address.USER_VALIDATED) delete customField.AQI;
        else if(AQI) customField.AQI = AQI;
        customField.addressValidationType = addressValidationType;
        const loqateInformation = JSON.stringify(customField);
        if(shouldUpdateAddress) {
            const updateCustomerResponse = await updateAddress({customerMeta, addressId :addressId, setDefaultAddress, customerAddressData : customerAddress, type, dispatch,loqateInformation});
            dispatch(customerApi.util.updateQueryData('getCustomerById', { customerId: user.userId }, (draft) => Object.assign({}, dispatch(createCustomerResponseModel(updateCustomerResponse, true, type)))));  
            return updateCustomerResponse;
        }
        else await dispatch(updateLoqateAddressField(user.userId,  addressId, customField));
    }
}

/**
 * Uses the response from the updateAddressAndLoqateField function to get an array of update responses.
 * @returns {Array} An array containing the update responses.
 */
const changeExistingAddressLoqateField = ({loqateShippingVerifyFlow = false, loqateBillingVerifyFlow = false, loqateShippingRecommendedFlow = false , loqateBillingRecommendedFlow = false }) => {
    return async (dispatch, getState) => {
        let { shippingState : { address: { defaultShippingAddress, shippingAddress, billingAddress, defaultBillingAddress},loqate : {shippingAQI, billingAQI, shippingAddressType, billingAddressType}}} = getState();

        let updatedShippingAddress :any = '', updatedBillingAddress :any = '';

        if (Object.keys(defaultShippingAddress).length && loqateShippingVerifyFlow) {
            updatedShippingAddress = await dispatch(updateAddressAndLoqateField({
                shouldUpdateAddress : loqateShippingRecommendedFlow,
                AQI : shippingAQI,
                setDefaultAddress : true,
                addressValidationType : shippingAddressType,
                customerAddress : shippingAddress,
                addressId : defaultShippingAddress.id,
                type: Address.SHIPPING
            }));
        } 

        if (Object.keys(defaultBillingAddress).length && loqateBillingVerifyFlow) {
            updatedBillingAddress = await dispatch(updateAddressAndLoqateField({
                shouldUpdateAddress : loqateBillingRecommendedFlow,
                AQI : billingAQI,
                setDefaultAddress : true,
                addressValidationType : billingAddressType,
                customerAddress : billingAddress,
                addressId : defaultBillingAddress.id,
                type: Address.BILLING
            }));
        }
        return [updatedShippingAddress, updatedBillingAddress];
    }
}
const getRecommendAddress = (address) => {
    return async (dispatch, getState) => {
        dispatch(setShowShippingError(false));
        const formattedAddressObj = {};
        //don't send county info in case of UK
        if (address.country === 'GB') {
            formattedAddressObj['AdministrativeArea'] = '';
        } else if (address.country === 'NZ') {
            formattedAddressObj['District'] = address.state;
        } else {
            formattedAddressObj['AdministrativeArea'] = address.state;
        }
        formattedAddressObj['Address1'] = address.streetName;
        formattedAddressObj['Address2'] = address.additionalStreetInfo;
        formattedAddressObj['Locality'] = address.city;
        formattedAddressObj['PostalCode'] = address.postalCode;
        formattedAddressObj['Country'] = address.country;

        try {
            const payload = {
                'Geocode': true,
                Options: {
                    Process: 'Verify'
                },
                'Addresses': [formattedAddressObj]
            };
            const response = await dispatch(loqateApi.endpoints.getRecommendAddress.initiate({ ...payload }));

            if (response?.data) return response.data;
        } catch (err: any) {
            const errorMessage = err?.message;
            dispatch(setShowShippingError(true));
            dispatch(setShippingError(errorMessage));
        }
    }
}

const getDisplayContactPref = (data) => {
    try{
        let preference = data?.subscribe;
        const localPref = getFromLocalStorage('contactPref');
        if (localPref && (localPref.email === data?.emailAddress)) {
            preference = localPref.consent;
        }
            return preference;
        }
    catch(error){
        console.log(error);
    }
  }

const getPreference = (email) => {
    return async (dispatch) =>{
        try{
            const encodedEmail = encodeURIComponent(email);
            const response = await dispatch(customerGdprAPI.endpoints.getContactPreference.initiate({ email: encodedEmail?.trim() }));
            const preference = getDisplayContactPref(response.data?.data);
            
            if(config('regionCode') === 'US'){
                setInLocalStorage('contactPref', {
                    'email': email,
                    'consent': preference === 'N/A' || preference === 'Y' ? 'Y' : 'N'
                });
                if( preference === 'N/A' ) newsletterEvent('shipping');
            }
            else if(preference !== 'N/A'){
                setInLocalStorage('contactPref', {
                    'email': email,
                    'consent': preference
                });
            }

            dispatch(setContactPreferencesState( response.data?.data?.emailAddress , config('regionCode') === 'US' && preference === 'N/A'? 'Y' : preference, 'false', false, response?.data?.data?.subscribe=='Y' ? false: true ));
        }
        catch(error){
          console.log(error);
        }
        finally{
          dispatch(checkIsEmailChanged({isEmailChanged: false}))
        }
    }
  } 

const setDNSinfo = (email) => {
    return async (dispatch) => {
        try {
            const { data } = await dispatch(customerApi.endpoints.getCustomerDataPreference.initiate({ email }));
            if (data?.data?.rent) {
                setCookieForSession('np.rent', data.data.rent, '/');
            }
        } catch (error) {
            console.error('Error fetching customer data preference:', error);
        }
    };
};

const getEmailValidated = (email) => {
    return async (dispatch, getState) => {
        try {
            const res = await dispatch(loqateApi.endpoints.getEmailValidated.initiate({ email: email?.trim() }));
            
            if (!(res?.data?.Items?.length === 1 && typeof (res?.data?.Items[0]?.Error) != 'undefined')) {
                if (res.data.Items[0]?.ResponseCode === EmailValidationStatus.INVALID) {
                        throw new Error('Invalid Email');
                }
            }
            dispatch(setValidatedEmail(email));
            dispatch(setDNSinfo(email));
            dispatch(getPreference(email));
            
        }
        catch (err) {
            console.log(err);
            dispatch(setIsValidEmail('false'))
        }
    }
}

const resetShippingState = () => {
    return (dispatch) => {
        dispatch(setShowShippingError(false));
        dispatch(setShippingError(''));
        dispatch(setCartAddressAdded(false));
        dispatch(setBackToPreviousPage(false));
        dispatch(setShippingBillingAgreement(false));
        dispatch(setShipAddressModified(true));
        dispatch(setBillAddressModified(true));
        dispatch(setIsManualShippingAddress(false));
        dispatch(setIsManualBillingAddress(false));
        dispatch(setDefaultShippingAddress(false));
        dispatch(setDefaultBillingAddress(false));
        dispatch(setMoveToPaymentPage(false));
        dispatch(setTaxRateActions([]));
        dispatch(setLoginUserEditFormState(LoginUserEditFormState.CLOSE, '', Address.SHIPPING, true, '', ''));
        dispatch(shippingSlice.actions.setLoqateInitialState({}));
    }
}

const isAddressInvalid = (addressData,addressForm,addressType, shippingBillingAgreement) => {
    const requiredFields = ['email', 'firstName', 'lastName', 'phone', 'streetName', 'city', 'postalCode'];
    const isNASite = config('isNASite');
    
    // US, CA, AU, IT and ES have state field as mandatory in Address form
    if (isNASite || ['ES', 'IT', 'AU'].includes(addressData?.country)) {
        requiredFields.push('state');
    }
    // Except US and CA all other locales have country field as mandatory in Address form
    if (!isNASite) {
        requiredFields.push('country');
    }
    //Selection of address form type to be compared with address data
    const addressFormType = (addressType === Address.BILLING_ADDRESS && !shippingBillingAgreement) ? Address.BILLING_ADDRESS : Address.SHIPPING_ADDRESS;

    //Checks to see if first name or lastname are invalid 
    const isFirstNameInvalid = (addressForm?.[addressFormType]?.firstName?.value).trim() !== addressData?.firstName || !((addressData?.firstName).length <= 24);
    const isLastNameInvalid = (addressForm?.[addressFormType]?.lastName?.value).trim() !== addressData?.lastName || !((addressData?.lastName).length <= 24);
    
    return requiredFields.some(field => !addressData?.[field]) || isFirstNameInvalid || isLastNameInvalid;
};

const missingCartFieldsSentryLog = (addressType, sentryErrorType, sentryErr) => {
    logSentry({
        'page': 'checkoutShipping',
        'feature': 'Missing Address Fields',
        'operation': `${addressType}  missing`,
        'errorType': sentryErrorType,
        'err': sentryErr,
        'func': 'proceedToPayment',
        'api': null,
        'errMsg': `Error: ${addressType} , missing required fields`
    });
}

const getFieldNames = (addressType, addressForm) => {
    if (addressType === Address.SHIPPING_ADDRESS) {
        return shippingUtils.getAddressFieldNames(addressForm?.shippingAddress?.country?.value || config('regionCode'));
    } else if (addressType === Address.BILLING_ADDRESS) {
        return shippingUtils.getAddressFieldNames(config('regionCode'));
    }
}

const refetchAddressAndLogSentry = (addressType, address, addressForm, shippingBillingAgreement, user, customer, newShippingAddress?) => {
    let sentryErrorType = shippingBillingAgreement ? `${addressType} empty, agreement is true` : `${addressType} empty, agreement is false`;
    let sentryErr = JSON.stringify(address);
    if(addressType === Address.BILLING_ADDRESS && shippingBillingAgreement){
        missingCartFieldsSentryLog(addressType, sentryErrorType, sentryErr);
        return JSON.parse(JSON.stringify(newShippingAddress))
    }else{
        if (addressForm[addressType] && shippingUtils.isAddressValid(getFieldNames(addressType, addressForm), addressForm[addressType])) {
            const { shippingData, billingData } = shippingUtils.getShippingBillingAddress(addressForm, shippingBillingAgreement, user?.isLoggedIn, customer?.email);
            missingCartFieldsSentryLog(addressType, sentryErrorType, sentryErr);
            return addressType === Address.SHIPPING_ADDRESS ? shippingData : billingData;
        } else {
            sentryErrorType += ', addressForm invalidated';
            sentryErr = JSON.stringify(addressForm);
            missingCartFieldsSentryLog(addressType, sentryErrorType, sentryErr);
            throw new Error(`Invalid ${addressType}`);
        }
    }
}

// Check if any of the required fields are missing from shipping or billing address
const validateMissingFieldsInAddress = (shippingAddress, billingAddress,addressForm,shippingBillingAgreement,user,customer,dispatch, addLoqateInfo = false) => {
    let newShippingAddress = JSON.parse(JSON.stringify(shippingAddress));
    let newBillingAddress = JSON.parse(JSON.stringify(billingAddress));

    //If Shipping address is Invalid refetch the shipping address
    if(isAddressInvalid(shippingAddress,addressForm, Address.SHIPPING_ADDRESS, shippingBillingAgreement)){    
        newShippingAddress = refetchAddressAndLogSentry(Address.SHIPPING_ADDRESS, shippingAddress, addressForm, shippingBillingAgreement, user, customer);
        if(addLoqateInfo) newShippingAddress = addLoqateInformationInAddress( newShippingAddress , Address.SHIPPING_ADDRESS, Address.USER_VALIDATED , dispatch ) //add loqate information in address
        dispatch(setShippingAddress(JSON.parse(JSON.stringify(newShippingAddress))));
    }
    //If Billing address is Invalid refetch the billing address
    if(isAddressInvalid(billingAddress,addressForm, Address.BILLING_ADDRESS, shippingBillingAgreement)){
        newBillingAddress = refetchAddressAndLogSentry(Address.BILLING_ADDRESS, billingAddress, addressForm, shippingBillingAgreement, user, customer, newShippingAddress);
        if(addLoqateInfo) newBillingAddress = addLoqateInformationInAddress( newBillingAddress , Address.BILLING_ADDRESS, Address.USER_VALIDATED , dispatch ) //add loqate information in address
        dispatch(setBillingAddress(JSON.parse(JSON.stringify(newBillingAddress))));
    }

    return { newShippingAddress, newBillingAddress }
}

const validateMissingFieldsInAddressMyAccount = (address, addressType, addressForm, user, customer) => {
    let newAddress = JSON.parse(JSON.stringify(address));
    
    //If address is Invalid refetch the address
    if(isAddressInvalid(newAddress, addressForm, addressType, false)){  
        let sentryErrorType = `${addressType} empty`;
        let sentryErr = JSON.stringify(address);  
        if (addressForm[addressType] && shippingUtils.isAddressValid(getFieldNames(addressType, addressForm), addressForm[addressType])) {
            const { shippingData, billingData } = shippingUtils.getShippingBillingAddressMyAccount(addressForm, addressType, user?.isLoggedIn, customer?.email);
            missingAddressFieldsSentryLog(addressType, sentryErrorType, sentryErr);
            newAddress = addressType === Address.SHIPPING_ADDRESS ? JSON.parse(JSON.stringify(shippingData)) : JSON.parse(JSON.stringify(billingData));
        } else {
            sentryErrorType += ', addressForm invalidated';
            sentryErr = JSON.stringify(addressForm);
            missingAddressFieldsSentryLog(addressType, sentryErrorType, sentryErr);
            throw new Error(`Invalid ${addressType}`);
        }
    }
    return { newAddress }
}

const missingAddressFieldsSentryLog = (addressType, sentryErrorType, sentryErr) => {
    logSentry({
        'page': 'MyAcccount',
        'feature': 'Missing Address Fields',
        'operation': `${addressType}  missing`,
        'errorType': sentryErrorType,
        'err': sentryErr,
        'func': 'validateMissingFieldsInAddressMyAccount',
        'api': null,
        'errMsg': `Error: ${addressType} , missing required fields`
    });
}

const addLoqateInformationInAddress = ( address , type , addressType , dispatch , AQI = '' )=>{

    let newAddress : any = JSON.parse(JSON.stringify(address));
    newAddress.custom = {
        fields: {
            ...newAddress?.custom?.fields,
            loqateInformation : addressType === Address.LOQATE_VALIDATED ? `{\"AQI\":\"${AQI}\",\"addressValidationType\":\"${Address.LOQATE_VALIDATED}\"}` : `{\"addressValidationType\":\"${Address.USER_VALIDATED}\"}`
        },
    };
    type === Address.SHIPPING_ADDRESS ? dispatch(setShippingAddress(newAddress)) : dispatch(setBillingAddress(newAddress));

    return newAddress;
}

const proceedToPayment = (params = {}) => {
    return async (dispatch, getState) => {
        try {
            const { applicationState: { user, vatToken,coupon,isShippingDisc }, shippingState: { address: {shippingBillingAgreement, currentSelectedCountry, isManualShippingAddress, isManualBillingAddress, defaultShippingAddress, defaultBillingAddress }, contactPreference: { subscribe }, loqate }, customerState: { customer } } = getState();
            let { shippingState: { address: { shippingAddress, billingAddress }, loqate: { shippingAddressType, billingAddressType, shippingAQI, billingAQI }}} = getState();
            const validatedAddress = validateMissingFieldsInAddress(shippingAddress,billingAddress,params['addressForm'],shippingBillingAgreement,user,customer,dispatch)
            const cart = JSON.parse(JSON.stringify(getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {}));
            shippingAddress = validatedAddress.newShippingAddress;
            billingAddress = validatedAddress.newBillingAddress;
            const cartId = user.cartId, vatId = shippingAddress.vatId || shippingAddress.taxRegisterationNum, token = vatToken, email = shippingAddress.email;
            const actions: any = [], apiPromises : any = [];
            const { isThresholdMet } = calculateThresholdStatus(cart, coupon?.thresholdValue);
            if(cart?.apparelItemExists){
                if(config('locale') === 'en-US' && (shippingAddress?.state === 'PR')){
                    const errorMessage = ErrorMessage.INVALID_STATE;
                    throw new Error(errorMessage);
                }
            }

            dispatch(setShowShippingError(false));
            dispatch(startLoading());

            apiPromises.push( 
                dispatch(validateVatNumber(dispatch, vatId, currentSelectedCountry, cartId, token))
            );
            
            if(user.isLoggedIn === 'true') {
                apiPromises.push(
                    ...(isManualShippingAddress || isManualBillingAddress ? [dispatch(addCustomerAddresses())] : []),
                    ...(defaultShippingAddress || defaultBillingAddress ? [dispatch(changeExistingAddressLoqateField(params))]: [])
                );
            }
            else {
                apiPromises.push(
                    dispatch(getCustomerDetailsByEmail()), 
                    dispatch(createGuestCustomer())                   
                );
                setCookieForSession('EmailFraud', email.replace('@', '##') , '/');           
                saveGuestAddressFormInStorage(shippingAddress, billingAddress, loqate);
            }

            const response = await Promise.all(apiPromises);

            // To set the address key for the logged-in user's shipping or billing address if it is created or edited.
            if (user.isLoggedIn === 'true') {
                // Initialize responseIndex to 1 because responses start at index 1. 
                // If isManualShippingAddress || isManualBillingAddress is true, addCustomerAddresses response will be at index 1.
                // Otherwise, changeExistingAddressLoqateField response will be at index 1.
                let responseIndex = 1;
                if (isManualShippingAddress || isManualBillingAddress) {
                    const addedAddressesResponse = response[responseIndex] || [];
                    const [newAddedShippingAddress, newAddedBillingAddress] = addedAddressesResponse;
            
                    // If a new shipping or billing address was added, update the Address object with its key
                    if (newAddedShippingAddress?.key) {
                        shippingAddress.key = newAddedShippingAddress.key;
                    }
                    if (newAddedBillingAddress?.key) {
                        billingAddress.key = newAddedBillingAddress.key;
                    }
                    // Increment responseIndex to access changeExistingAddressLoqateField response at index 2 if isManualShippingAddress || isManualBillingAddress is true.
                    responseIndex++;
                }
            
                if (defaultShippingAddress || defaultBillingAddress) {
                    const updatedCustomerResponse = response[responseIndex] || [];
                    const [updatedShippingAddress, updatedBillingAddress] = updatedCustomerResponse;
            
                    // If the shipping or billing address was updated, update the Address object with its modified key
                    if (updatedShippingAddress?.modifiedAddressKey) {
                        shippingAddress.key = updatedShippingAddress.modifiedAddressKey;
                    }
                    if (updatedBillingAddress?.modifiedAddressKey) {
                        billingAddress.key = updatedBillingAddress.modifiedAddressKey;
                    }
                }
            }

            const vatResponse = response[0];

            let customerId = window.np.loggedInSessionMgr.getId();
            if (user.isLoggedIn === 'false') {
                customerId = response[1] || response[2] || '';
                setCookie('np.customerId', customerId);
                window.reorder?.fetchInfo(); // fetch reorder info
                window?.np?.enhanceHotjarUserAttributes({"customerId":customerId})
                if(config('isNASite')){
                    dispatch(customerGdprAPI.endpoints.setContactPreference.initiate({
                        'emailAddress': email,
                        'userConsent': subscribe,
                        'countryCode': config('regionCode'),
                        'reference': 'website-ABC-' + config('regionCode') + '-checkout | ' + i18n.t('customer_service.exclusive_offers'),
                        'source': window.location.href,
                        'language':config('language')
                    }))
                }
                const rent = get('np.rent');
                if(window?.OneTrust){
                    if(rent === 'N'){
                        window?.OneTrust?.RejectAll();
                    }else{
                        window?.OneTrust?.AllowAll();
                    }
                }
            }

            //Add loqate information in address custom field
            shippingAddress = addLoqateInformationInAddress(shippingAddress, Address.SHIPPING_ADDRESS, shippingAddressType, dispatch, shippingAQI);
            if (shippingBillingAgreement) billingAddress = shippingAddress;
            else billingAddress = addLoqateInformationInAddress(billingAddress, Address.BILLING_ADDRESS, billingAddressType, dispatch, billingAQI);

            //added additional checks and handling : ABC-27378
            const {newShippingAddress, newBillingAddress} = validateMissingFieldsInAddress(shippingAddress,billingAddress,params['addressForm'],shippingBillingAgreement,user,customer,dispatch,true)

            actions.push(...[
                { 'action': 'shippingAddress', 'value': newShippingAddress },
                { 'action': 'billingAddress', 'value': newBillingAddress },
                { 'action': 'customerId', 'value': customerId },
                { 'action': 'customerEmail', 'value': newShippingAddress.email },
                { 'action': 'customField',  'value' :  {'name': 'shippingAtLineItemLevel', 'value': true }},
                { 'action': 'customField', 'value' : {'name': 'taxIdentificationNumber', 'value': vatResponse === 'valid' ? vatId : ''} },
                { 'action': 'customField', 'value' : {'name': 'orderAcquisitionChannel', 'value': JSON.stringify({ 'referrer_url': window.locale_details.site_baseurl, 'source': 'website', 'source_crm_agent': false })} },
                { 'action': 'customField', 'value' : {'name': 'fakeOrder', 'value': !get('fake') || get('fake') === 'false' ? 'false' : 'true'} },
                { 'action': 'customField', 'value' : {'name': 'orderUserFlow', 'value': user.isLoggedIn === 'true' ? 'loggedin' : 'guest'}},
                { 'action': 'customField', 'value' : {'name': 'orderType', 'value': sessionStorage?.getItem('utm_source') || "Web"}}
            ]);

            // Only update VAT ID if the VAT response is valid and the user is logged in
            if (vatResponse === 'valid' && user.isLoggedIn === 'true') {
                dispatch(updateVatId(vatId));
            }

            const doesDiscountExistOnShipping = (cart?.discountExists || (!cart?.shippingCustomItem && coupon?.thresholdValue && isThresholdMet && isShippingDisc) || (!cart?.shippingCustomItem && !coupon?.thresholdValue && isShippingDisc)) ?? false;
            dispatch(setIsCouponAppliedOnShipping(doesDiscountExistOnShipping))

            const updateCartData = await dispatch(newCartApi.endpoints.updateCart.initiate({
                cartId, 
                actions,
                setUserType: true
            }));
            const updateCartResponse = updateCartData?.data?.data?.attributes;
            
            if(updateCartResponse !== null && updateCartResponse !== undefined && updateCartResponse?.id){
                let sentryErrorType = '';
                const requiredFields = [
                    { value: updateCartResponse?.shippingAddress, name: Address.SHIPPING_ADDRESS },
                    { value: updateCartResponse?.billingAddress, name: Address.BILLING_ADDRESS },
                    { value: updateCartResponse?.customerId, name: 'customer id' },
                    { value: updateCartResponse?.customerEmail, name: 'customer email' },
                    { value: updateCartResponse?.custom?.fields?.orderType, name: 'order type' },
                ];
                //Check to see if any of the required fields are invalid
                requiredFields.forEach(({ value, name }) => {
                    sentryErrorType += (name === Address.SHIPPING_ADDRESS || name === Address.BILLING_ADDRESS) 
                        ? (isAddressInvalid(value,params['addressForm'],name,shippingBillingAgreement) ? `Missing Cart Field -- ${name}, ` : '')
                        : (value === undefined || value == null || value === '') ? `Missing Cart Field -- ${name}, ` : '';
                });

                if(sentryErrorType !== ''){
                    const errorData = JSON.stringify({
                        missingCartFields: sentryErrorType,
                        actions: actions
                    });
                    const obj = {
                        'page': 'checkoutShipping',
                        'feature': 'Missing fields in Cart',
                        'operation': 'proceedToPayment',
                        'errorType': 'Missing fields in Cart Sentry Error',
                        'err': errorData,
                        'func': 'Missing fields in Cart',
                        'api': null,
                        'errMsg': 'Missing fields in Cart'
                    }
                    console.log("Missing fields from cart object: ",JSON.stringify(obj))
                    logSentry(obj);  
                }     
            }else{
                throw new Error('No response from updateCart');
            }

            let newCart: Cart = new Cart(updateCartResponse);
            dispatch(newCartApi.util.updateQueryData('getCartByCartId', {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, (draft) => Object.assign({}, newCart)));


            dispatch(setMoveToPaymentPage(true));
            dispatch(stopLoading());
            
        } catch (err:any) {
            let errorMsg = i18n.t('sign_up.somethingWrong_GA');
            if(err?.message === ErrorMessage.INVALID_STATE){
                errorMsg = i18n.t('checkout_shipping.invalid_address_error');
            }
            dispatch(stopLoading());
            dispatch(setShowShippingError(true));
            errorTrackingGaEvent('checkout-shipping', errorMsg);
            dispatch(setShippingError(errorMsg));
            logSentry({
                'page': 'checkoutShipping',
                'feature': 'proceedToPayment',
                'operation': 'proceedToPayment',
                'errorType': 'ajaxError',
                'err': JSON.stringify(err),
                'func': 'proceedToPayment',
                'api': null,
                'errMsg': 'Error: while proceed to payment'
            })
        }
    }
}

const checkIsEmailChanged = ({isEmailChanged}) => {
    return async (dispatch) => {
        try{
            dispatch(shippingSlice.actions.checkIsEmailChanged({isEmailChanged}));
        }catch(error){
            throw error;
        }
    }
}


export default {
    setShippingAddress,
    setBillingAddress,
    setShowShippingError,
    setShippingError,
    setShippingBillingAgreement,
    setCustomerVersion,
    setCurrentSelectedCountry,
    saveModifiedAddress,
    updateAddressesInCustomer,
    validateReCaptcha,
    validatePreferanceReCaptcha,
    proceedToPayment,
    updateOrderSummaryForVat,
    getVatExemption,
    setOldVatId,
    setOldVatCountry,
    setVatStatus,
    setIsManualShippingAddress,
    setIsManualBillingAddress,
    setDefaultShippingAddress,
    setDefaultBillingAddress,
    setOldVat,
    setOldUsbVat,
    setUpdateVatMsg,
    setShipAddressModified,
    setBillAddressModified,
    setIsValidEmail,
    setIsPostalCodeBlur,
    setValidatedEmail,
    setMoveToPaymentPage,
    setLoqateEnabled,
    setSuggestedShippingAddress,
    setSuggestedBillingAddress,
    setShippingAddressType,
    setBillingAddressType,
    setCartAddressAdded,
    setBackToPreviousPage,
    setIsLoqateSuggestedAddress,
    setBlockShippingLoqateAutocomplete,
    setBlockBillingLoqateAutocomplete,
    setShippingAQI,
    setBillingAQI,
    getRecommendAddress,
    getEmailValidated,
    setFormattedShippingAddress,
    setFormattedBillingAddress,
    setShowShippingPopup,
    setShowBillingPopup,
    setLoginUserEditFormState,
    updateLoqateAddressField,
    setContactPreferencesState,
    resetShippingState,
    checkIsEmailChanged,
    getPreference,
    updateLoqateAddressFieldMyAccount,
    validateMissingFieldsInAddress,
    validateMissingFieldsInAddressMyAccount,
    loqateModalFunction,
    myAccountABCCalls
}
